import {Component, EventEmitter, Inject, Input, OnChanges, OnDestroy, OnInit, Output} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {PayrollService} from '../../../services/payroll/payroll.service';
import {SavedTeamSettings, WorkforceTeamSettingsState} from '../../../services/payroll-workforce/workforce-team-settings.state';

@Component({
  selector: 'app-payroll-team-settings',
  template: `<button *ngIf="managed" mat-menu-item (click)="edit()"><mat-icon>edit</mat-icon><span>Edit settings</span></button>`,
})
export class PayrollTeamSettingsComponent implements OnChanges, OnDestroy {
  @Input() companyId = '';
  @Input() teamId = '';
  @Output() saved = new EventEmitter<SavedTeamSettings>();
  managed = false;
  private version = 0;
  private ref: MatDialogRef<PayrollTeamSettingsDialogComponent, SavedTeamSettings> | null = null;

  constructor(private api: PayrollService, private dialog: MatDialog) {}

  ngOnChanges(): void {
    const version = ++this.version;
    this.managed = false;
    this.closeDialog();
    if (!this.companyId || !this.teamId) { return; }
    void this.api.getWorkforceTeamSettings(this.companyId, this.teamId).then(value => {
      if (version === this.version) {
        this.managed = value?.managed === true && value.companyId === this.companyId && value.teamId === this.teamId;
      }
    }).catch(() => { /* Only backend-confirmed managed teams expose this action. */ });
  }

  ngOnDestroy(): void { ++this.version; this.closeDialog(); }

  edit(): void {
    if (!this.managed || this.ref) { return; }
    const version = this.version;
    const ref = this.dialog.open<PayrollTeamSettingsDialogComponent, {companyId: string; teamId: string}, SavedTeamSettings>(
      PayrollTeamSettingsDialogComponent, {width: '460px', maxWidth: '95vw', data: {companyId: this.companyId, teamId: this.teamId}}
    );
    this.ref = ref;
    ref.afterClosed().subscribe(value => {
      if (this.ref === ref) { this.ref = null; }
      if (version === this.version && value?.companyId === this.companyId && value.teamId === this.teamId) { this.saved.emit(value); }
    });
  }

  private closeDialog(): void {
    if (this.ref) { this.ref.componentInstance.state.destroy(); this.ref.close(); this.ref = null; }
  }
}

@Component({selector: 'app-payroll-team-settings-dialog', templateUrl: './payroll-team-settings-dialog.component.html'})
export class PayrollTeamSettingsDialogComponent implements OnInit, OnDestroy {
  readonly state: WorkforceTeamSettingsState;

  constructor(api: PayrollService,
              private ref: MatDialogRef<PayrollTeamSettingsDialogComponent, SavedTeamSettings>,
              @Inject(MAT_DIALOG_DATA) private data: {companyId: string; teamId: string}) {
    this.state = new WorkforceTeamSettingsState(api);
  }

  ngOnInit(): void { void this.state.open(this.data.companyId, this.data.teamId); }
  ngOnDestroy(): void { this.state.destroy(); }

  async save(): Promise<void> {
    this.ref.disableClose = true;
    try {
      const result = await this.state.save();
      if (result) { this.ref.close(result); }
    } finally { this.ref.disableClose = false; }
  }
}
